import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'

function ProductText(props){
  const [productText] = useEnvValue('productText')

  if(typeof productText !== "string" || productText.length < 1) return null

  return (
    <div className="mtt-single-product__information-container" dangerouslySetInnerHTML={{ __html: productText }}></div>
  )
}

export default ProductText